import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './index.module.css';

const PromoBanner = ({
  content,
  linkUrl,
  bgColor = '#007B3A',
  fgColor = '#fff',
  buttonLabel,
  buttonBorderColor,
  buttonForeColor,
  allowDismissal = true,
  useDarkDismissalButton = false
}) => {
  const [dismissed, setDismissed] = useState(false);
  const [animating, setAnimating] = useState(false);

  if (!content || dismissed) return null;

  const handleDismiss = () => {
    setAnimating(true);
    setTimeout(() => setDismissed(true), 300);
  };

  const bannerStyle = { backgroundColor: bgColor, color: fgColor };
  const buttonStyle = buttonBorderColor
    ? { borderColor: buttonBorderColor, color: buttonForeColor }
    : undefined;

  const innerContent = (
    <div className="promo-banner__text-container">
      <p className="promo-banner__text">{content}</p>
      {linkUrl && buttonLabel && (
        <p className="promo-banner__styled-text" style={buttonStyle}>
          {buttonLabel}
        </p>
      )}
      {allowDismissal && (
        <button
          className="promo-banner__close-button"
          type="button"
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDismiss(); }}
          aria-label="Close banner"
        >
          <img
            className="promo-banner__close-button-image"
            src={useDarkDismissalButton
              ? '/images/icons/cross-icon.svg'
              : '/images/icons/cross-icon-blue.svg'}
            alt=""
          />
        </button>
      )}
    </div>
  );

  const bannerClass = `promo-banner${animating ? ' promo-banner--animated' : ''}`;

  return (
    <div className={bannerClass} style={bannerStyle}>
      {linkUrl ? (
        <a className="promo-banner__wrapper-link" href={linkUrl}>
          {innerContent}
        </a>
      ) : (
        <span className="promo-banner__wrapper-link">
          {innerContent}
        </span>
      )}
    </div>
  );
};

PromoBanner.propTypes = {
  content: PropTypes.string,
  linkUrl: PropTypes.string,
  bgColor: PropTypes.string,
  fgColor: PropTypes.string,
  buttonLabel: PropTypes.string,
  buttonBorderColor: PropTypes.string,
  buttonForeColor: PropTypes.string,
  allowDismissal: PropTypes.bool,
  useDarkDismissalButton: PropTypes.bool
};

export default PromoBanner;
